import { render, staticRenderFns } from "./ListCreativeReviews.vue?vue&type=template&id=e9b9e1c0&scoped=true"
import script from "./ListCreativeReviews.vue?vue&type=script&lang=js"
export * from "./ListCreativeReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b9e1c0",
  null
  
)

export default component.exports